/* eslint-disable radix */
/* eslint-disable arrow-body-style */
import { Reducer } from 'redux';
import { Category, MerchantsState, MerchantsTypes, Product } from './types';
import {
  getProductsAvailabilityUpdated,
  getProductAvailabilityUpdated,
  getProductUpdated,
  getProductCurrentStockUpdated,
} from '../../../services/functions';

const INITIAL_STATE: MerchantsState = {
  id: '',
  urlCode: '',
  status: '',
  name: '',
  cnpj: '',
  phoneDdd: '',
  phoneNumber: '',
  email: '',
  logoPath: '',
  bannerPath: '',
  about: '',
  whatsappDdd: '',
  whatsappNumber: '',
  instagram: '',
  facebook: '',
  active: false,
  address: {
    street: '',
    streetNumber: '',
    complement: '',
    neighborhood: '',
    city: '',
    cityCode: '',
    state: '',
    country: '',
    postalCode: '',
    reference: '',
    latitude: 0,
    longitude: 0,
  },
  marketSegment: {
    code: '',
    name: '',
  },
  marketplace: false,
  ratings: {
    average: 0,
    number: 0,
    type: '',
  },
  settings: {
    deliveryTimeMin: 0,
    deliveryTimeMax: 0,
    deliveryFeeMin: 0,
    softcomShip: { active: false, clientId: '', clientSecret: '' },
  },
  deliveryTimeMin: 0,
  deliveryTimeMax: 0,
  deliveryFeeMin: 0,
  showProductUnavailableInApp: false,
  availability: [],
  deliveryMethods: [],
  deliveryAreas: [],
  payments: [],
  loaded: false,
  exist: true,
  categories: [
    {
      merchantId: '',
      id: '',
      code: null,
      name: '',
      priority: 0,
      availability: '',
      products: [],
    },
  ],
  paymentInstructions: '',
  orderCpfIsRequired: false,
  cardInstallmentsMax: 0,
  cardInstallmentsMinValue: 0,
  sitefMerchantId: null,
  sitefMerchantKey: null,
  softcomCode: '',
  integrationApp: false,
};

const reducer: Reducer<MerchantsState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MerchantsTypes.LOAD_MERCHANT:
      return {
        ...state,
        ...action.payload,
      };

    case MerchantsTypes.HANDLE_EXIST:
      return {
        ...state,
        exist: action.payload,
      };

    case MerchantsTypes.UPDATE_MERCHANT_AVAILABILITY:
      if (action.data.merchantId === state.id) {
        return {
          ...state,
          status: action.data.availability,
        };
      }
      return state;

    case MerchantsTypes.UPDATE_MERCHANT_CATEGORY_AVAILABILITY:
      if (action.data.merchantId === state.id) {
        if (action.data.availability === 'UNAVAILABLE') {
          return {
            ...state,
            categories: state.categories.map((category: Category) =>
              category.id === action.data.categoryId
                ? {
                    ...category,
                    availability: action.data.availability,
                    products: getProductsAvailabilityUpdated(
                      category.products,
                      action.data.availability,
                    ),
                  }
                : category,
            ),
          };
        }
      }
      return state;

    case MerchantsTypes.UPDATE_MERCHANT_PRODUCT_AVAILABILITY:
      if (action.data.merchantId === state.id) {
        return {
          ...state,
          categories: state.categories.map((category: Category) => {
            return category.id === action.data.categoryId
              ? {
                  ...category,
                  products: getProductAvailabilityUpdated(
                    category.products,
                    action.data.productId,
                    action.data.availability,
                    category,
                  ),
                }
              : category;
          }),
        };
      }
      return state;

    case MerchantsTypes.UPDATE_MERCHANT_PRODUCT:
      if (action.data.merchantId === state.id) {
        return {
          ...state,
          categories: state.categories.map((category: Category) => {
            return category.id === action.data.categoryId
              ? {
                  ...category,
                  products: getProductUpdated(
                    category.products,
                    action.data.productId,
                    JSON.parse(action.data.data),
                  ),
                }
              : category;
          }),
        };
      }
      return state;

    case MerchantsTypes.UPDATE_MERCHANT_PRODUCT_CURRENT_STOCK:
      if (action.data.merchantId === state.id) {
        return {
          ...state,
          categories: state.categories.map((category: Category) => {
            return category.id === action.data.categoryId
              ? {
                  ...category,
                  products: getProductCurrentStockUpdated(
                    category.products,
                    action.data.productId,
                    parseInt(action.data.stock),
                  ),
                }
              : category;
          }),
        };
      }
      return state;

    case MerchantsTypes.LOAD_CATEGORIES:
      if (!state.showProductUnavailableInApp) {
        const categories: Category[] = [];
        action.payload.map((category: Category) => {
          const productsTemp: Product[] = category.products.filter(
            (product: Product) => product.availability === 'AVAILABLE',
          );
          return (
            productsTemp.length > 0 &&
            categories.push({ ...category, products: productsTemp })
          );
        });
        return {
          ...state,
          categories,
          loaded: true,
          exist: true,
        };
      }
      return {
        ...state,
        categories: action.payload,
        loaded: true,
        exist: true,
      };

    case MerchantsTypes.CLEAR_MERCHANT:
      return {
        ...state,
        id: '',
        urlCode: '',
        status: '',
        name: '',
        cnpj: '',
        phoneDdd: '',
        phoneNumber: '',
        email: '',
        logoPath: '',
        bannerPath: '',
        about: '',
        whatsappDdd: '',
        whatsappNumber: '',
        instagram: '',
        facebook: '',
        active: false,
        address: {
          street: '',
          streetNumber: '',
          complement: '',
          neighborhood: '',
          city: '',
          cityCode: '',
          state: '',
          country: '',
          postalCode: '',
          reference: '',
          latitude: 0,
          longitude: 0,
        },
        marketSegment: {
          code: '',
          name: '',
        },
        marketplace: false,
        ratings: {
          average: 0,
          number: 0,
          type: '',
        },
        settings: {
          deliveryTimeMin: 0,
          deliveryTimeMax: 0,
          deliveryFeeMin: 0,
          softcomShip: { active: false, clientId: '', clientSecret: '' }
        },
        deliveryTimeMin: 0,
        deliveryTimeMax: 0,
        deliveryFeeMin: 0,
        showProductUnavailableInApp: false,
        availability: [],
        deliveryMethods: [],
        deliveryAreas: [],
        payments: [],
        loaded: false,
        exist: true,
        categories: [
          {
            merchantId: '',
            id: '',
            code: null,
            name: '',
            priority: 0,
            availability: '',
            products: [],
          },
        ],
        paymentInstructions: '',
        orderCpfIsRequired: false,
        cardInstallmentsMax: 0,
        cardInstallmentsMinValue: 0,
        sitefMerchantId: null,
        sitefMerchantKey: null,
        softcomCode: '',
        integrationApp: false,
      };

    default:
      return state;
  }
};

export default reducer;
